import React, { useState, useEffect, useRef } from 'react'
import { Card, Row, Col, ConfigProvider, Popover, Spin } from 'antd'
import dayjs from 'dayjs'
import _ from 'lodash'
import {
  getAsnStatsTable,
  getAsnCaseTrend,
  getReturnGradePie,
  getAsnWhStatusWaterfall,
  getAsnLeadTime,
  getAsnAbnormalTreemap
} from '@/services/returnReport/whOperation'
import AntdTable from '@/components/table/AntdTable'
import EchartsComMemo from '@/components/echarts/EchartsComMemo'
import { getConfigQuery } from '@/services/orderQuery/byBatch'
import SearchBar from '@/components/searchbar/SearchBar'
import {
  formatMessage,
  formatStartTime,
  formatEndTime,
  dateFormatYearMonthDay,
  dateFormatYearMonthDay2,
  dateFormatMonthDayYear2,
  initDateFormat,
  numFormat,
  uniqueFun,
  initValueAndLabel
} from '@/utils/common'
import './whOperation.less'
import { PACKAGE_TYPE, TIME_RANGE, GREEN_CHANNEL } from '@/utils/types'

const defaultStartTime = dayjs().add(-30, 'd')
const defaultEndTime = dayjs()
let defaultEchartLeftProps = {
  legend: {
    bottom: 0
  },
  grid: {
    left: '3%',
    top: '3%',
    right: '3%',
    bottom: 60,
    containLabel: true
  },
  dataZoom: [
    {
      show: true,
      height: 10,
      startValue: 0,
      endValue: 9
    },
    {
      type: 'inside',
      show: true,
      zoomLock: true,
      startValue: 0,
      endValue: 9
    }
  ],
  xAxis: {
    type: 'category',
    data: [],
    axisLabel: {
      margin: 20,
      rotate: 90 // 旋转45度
    }
  },

  yAxis: [
    {
      type: 'value',
      axisLabel: {
        formatter: value => {
          if (value) {
            return value.toFixed(2) * 1
          } else {
            return value
          }
        }
      }
    },
    {
      type: 'value',
      // 设置2号Y轴公用同一个水平线
      alignTicks: true,
      axisLabel: {
        formatter: value => {
          if (value) {
            return value.toFixed(2) * 1
          } else {
            return value
          }
        }
      }
    }
  ],

  series: []
}
let defaultEchartRightProps = {
  title: {
    text: 'Return Grade',
    left: 'center'
  },
  tooltip: {
    trigger: 'item'
  },
  legend: {
    bottom: 0
  },
  series: []
}
const WhOperation = props => {
  let formRefCommon = useRef(null)
  let formRefAbnomal = useRef(null)
  let formRefTime = useRef(null)
  let formRefWaterFall = useRef(null)
  const [tableList, setTableList] = useState([])
  const [tableListAbnormal, setTableListAbnormal] = useState([])
  const [tableListTimeLimit, setTableListTimeLimit] = useState([])
  const [tableListTreeMap, setTableListTreeMap] = useState([])
  const [echartLeftProps, setEchartLeftProps] = useState(defaultEchartLeftProps)
  const [echartRightProps, setEchartRightProps] = useState(defaultEchartRightProps)
  const [echartWaterfallProps, setEchartWaterfallProps] = useState({})
  const [echartTreeMapProps, setEchartTreeMapProps] = useState({})
  // 图渲染标志
  const [echartBarAndLineFlag, setEchartBarAndLineFlag] = useState(false)
  const [echartPieFlag, setEchartPieFlag] = useState(false)
  const [echartWaterFallFlag, setEchartWaterFallFlag] = useState(false)
  const [echartTreeMapFlag, setEchartTreeMapFlag] = useState(false)
  const [abnormalList, setAbnormalList] = useState([])
  const [nonAbnormalList, setNonAbnormalList] = useState([])
  const [echartBarAndLineFlagLoading, setEchartBarAndLineFlagLoading] = useState(false)
  const [echartPieFlagLoading, setEchartPieFlagLoading] = useState(false)
  const [echartWaterFallFlagLoading, setEchartWaterFallFlagLoading] = useState(false)
  const [echartTreeMapFlagLoading, setEchartTreeMapFlagLoading] = useState(false)
  const [abnormalLoading, setAbnormalLoading] = useState(false)
  const [tableListAbnormalLoading, setTableListAbnormalLoading] = useState(false)
  // 查询标志
  const [queryFlag, setQueryFlag] = useState(false)
  let searchListInitCommon = [
    {
      type: 'timeRange',
      label: 'languageObj.whOperation.whReceiveDate',
      key: 'whReceiveDate',
      showRangePresets: true,
      allowClear: false,
      format: dateFormatYearMonthDay,
      disabledDate: current => {
        let falg = current && current > dayjs().endOf('day')
        return falg
      },
      initialValues: [defaultStartTime, defaultEndTime],
      handleChange: (e, idx, item) => {
        searchDataBtn()
      },
      spans: {
        xl: 6,
        xxl: 6
      }
    },
    {
      type: 'select',
      label: 'languageObj.whOperation.channel',
      key: 'channel',
      allowClear: true,
      showAll: true,
      initialValues: [],
      mode: 'multiple',
      maxTagCount: 1,
      selectList: [],
      handleChange: (e, idx, item) => {
        searchDataBtn()
      },
      spans: {
        xl: 6,
        xxl: 6
      }
    },
    {
      type: 'select',
      label: 'languageObj.byBatchLocale.store',
      key: 'store',
      initialValues: [],
      mode: 'multiple',
      maxTagCount: 1,
      // maxTagTextLength: 10,
      showAll: true,
      selectList: [],
      handleChange: (e, idx, item) => {
        searchDataBtn()
      },
      spans: {
        xl: 6,
        xxl: 6
      }
    },
    {
      type: 'select',
      label: 'languageObj.whOperation.isGreenChannel',
      key: 'returnFlag',
      initialValues: 'ALL',
      selectList: GREEN_CHANNEL,
      handleChange: (e, idx, item) => {
        searchDataBtn()
      },
      spans: {
        xl: 6,
        xxl: 6
      }
    }
  ]
  const [searchListCommon, setSearchListCommon] = useState(searchListInitCommon)
  let searchListInitAbnomal = [
    {
      type: 'timeRange',
      label: 'languageObj.whOperation.caseClosedDate',
      key: 'caseClosedDate',
      showRangePresets: true,
      allowClear: false,
      format: dateFormatYearMonthDay,
      disabledDate: current => {
        let falg = current && current > dayjs().endOf('day')
        return falg
      },
      initialValues: [defaultStartTime, defaultEndTime],
      handleChange: (e, idx, item) => {
        searchDataBtnSec()
      },
      spans: {
        xl: 8,
        xxl: 6
      }
    },
    {
      type: 'select',
      label: 'languageObj.whOperation.packageType',
      key: 'packageType',
      initialValues: 'ALL',
      selectList: PACKAGE_TYPE,
      handleChange: (e, idx, item) => {
        searchDataBtnSec()
      },
      spans: {
        xl: 8,
        xxl: 6
      }
    }
  ]
  let searchListInitTime = [
    {
      type: 'select',
      label: 'languageObj.whOperation.timeRange',
      key: 'timespan',
      initialValues: 'DAY',
      selectList: TIME_RANGE,
      handleChange: (e, idx, item) => {
        getAsnCaseTrendFun()
      },
      spans: {
        xl: 10,
        xxl: 10
      }
    }
  ]
  let searchListInitWaterFall = [
    {
      type: 'select',
      label: 'languageObj.whOperation.packageType',
      key: 'packageType',
      initialValues: 'ALL',
      selectList: PACKAGE_TYPE,
      handleChange: (e, idx, item) => {
        getWaterFallData()
      },
      spans: {
        xl: 7,
        xxl: 7
      }
    }
  ]

  const tableColumns = [
    {
      title: ' ',
      dataIndex: 'title',
      width: 100,
      align: 'center',
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessage('languageObj.whOperation.caseClosed'),
      dataIndex: 'caseClosed',
      width: 100,
      align: 'center',
      render: text => {
        return <div className="word_break_all">{numFormat(text)}</div>
      }
    },
    {
      title: formatMessage('languageObj.whOperation.processLt'),
      dataIndex: 'avgLeadTime',
      width: 100,
      align: 'center',
      render: (text, record) => {
        return (
          <div className="word_break_all">
            {numFormat(record.avgLeadTimeH)} Hrs, {numFormat(record.avgLeadTimeD)} D
          </div>
        )
      }
    }
  ]
  const tableColumnsAbnormal = [
    {
      title: formatMessage('languageObj.whOperation.abnormalRatio'),
      dataIndex: 'value',
      width: 100,
      align: 'center',
      render: text => {
        return <div className="word_break_all">{text}%</div>
      }
    }
  ]
  const tableColumnsTimeLimit = [
    {
      title: formatMessage('languageObj.whOperation.returnShelfTime'),
      dataIndex: 'value',
      width: 100,
      align: 'center',
      render: text => {
        return <div className="word_break_all">{numFormat(text)}Hrs</div>
      }
    }
  ]
  const tableColumnsTreeMap = [
    {
      title: formatMessage('languageObj.whOperation.abnormalTypeTitle'),
      dataIndex: 'name',
      width: 100,
      align: 'center',
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessage('languageObj.whOperation.abnormalOrderNum'),
      dataIndex: 'value',
      width: 60,
      align: 'center',
      render: text => {
        return <div className="word_break_all">{numFormat(text)}</div>
      }
    },
    {
      title: formatMessage('languageObj.whOperation.abnormalPercent'),
      dataIndex: 'percent',
      width: 60,
      align: 'center',
      render: text => {
        return <div className="word_break_all">{text}%</div>
      }
    }
  ]
  useEffect(() => {
    // 获取店铺
    getConfigQueryFun()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  // 获取下拉框数据
  const getConfigQueryFun = () => {
    Promise.all([
      getConfigQuery({ configType: 'nike_shop_code' }),
      getConfigQuery({ configType: 'channel_name_config' })
    ]).then(res => {
      try {
        searchListInitCommon.forEach(itemFirst => {
          if (itemFirst.key === 'channel' || itemFirst.key === 'store') {
            let uniqueRes = []
            switch (itemFirst.key) {
              case 'store':
                let data0 = res[0].resultData || []
                uniqueRes = initValueAndLabel(data0, {
                  value: 'configKey',
                  label: 'configValue'
                })
                break
              case 'channel':
                let data1 = res[1].resultData || []
                for (let index = 0; index < data1.length; index++) {
                  const element = data1[index]
                  uniqueRes.push({
                    label: element.description,
                    value: element.configKey
                  })
                }
                break
              default:
                uniqueRes = []
                break
            }
            let unique = uniqueFun(uniqueRes)
            itemFirst.selectList = unique
          }
        })
        setSearchListCommon([...searchListInitCommon])
      } catch (error) {
        console.log(error)
      }
    })
  }
  useEffect(() => {
    getAllData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryFlag])
  const getAllData = () => {
    getWaterFallData()
    searchDataFun()
    getAsnCaseTrendFun()
    getReturnGradePieFun()
    getWarehouseLeadTime()
    getTreeMap()
  }
  const getTreeMap = () => {
    let info = getSearchInfo()
    const params = {
      ...info
    }
    setEchartTreeMapFlagLoading(true)
    getAsnAbnormalTreemap(params)
      .then(res => {
        const dt = res.resultData
        let seriesDatas = []
        _.forIn(dt, (value, key) => {
          seriesDatas.push({ value: value[0], name: key, percent: value[1] })
        })
        seriesDatas = _.orderBy(seriesDatas, ['value', 'percent'], ['desc', 'desc'])
        setEchartTreeMapProps(getTreeMapChartOption(seriesDatas))
        setTableListTreeMap(seriesDatas)
        setEchartTreeMapFlag(!echartTreeMapFlag)
      })
      .finally(() => {
        setEchartTreeMapFlagLoading(false)
      })
  }
  const getTreeMapChartOption = dataSeries => {
    let option = {
      color: [
        '#1f8ec0',
        '#2cbaf0',
        '#e97132',
        '#cc5516',
        '#14561d',
        '#cb3dbb',
        '#4ea72e',
        '#095f80',
        '#a02b93',
        '#2f641c',
        '#156082',
        '#0d3a4e',
        '#27a839',
        '#601a58',
        '#ed8d5b',
        '#114d68',
        '#196b24',
        '#0f9ed5',
        '#68cc45',
        '#0f4016',
        '#994010',
        '#c2dd55',
        '#ffd933',
        '#ff8a33',
        '#878aab',
        '#8d76bc'
      ],
      tooltip: {
        formatter: params => {
          if (params.dataIndex) {
            let str = `${params.marker} ${params.data.name}
            <br/>
            ${formatMessage('languageObj.whOperation.abnormalOrderNum')}: ${numFormat(params.data.value)}
            <br/>
            ${formatMessage('languageObj.whOperation.abnormalPercent')}: ${params.data.percent}%`
            return str
          } else {
            return ''
          }
        }
      },
      series: [
        {
          type: 'treemap',
          name: formatMessage('languageObj.whOperation.abnormalTypeTitle'),
          width: '100%',
          top: 0,
          bottom: 0,
          roam: false,
          nodeClick: false,
          breadcrumb: {
            show: false
          },
          levels: [
            {
              itemStyle: {
                borderWidth: 0,
                gapWidth: 3
              }
            },
            {
              itemStyle: {
                gapWidth: 1
              }
            }
          ],
          data: dataSeries
        }
      ]
    }
    return option
  }
  const getWarehouseLeadTime = () => {
    let info = getSearchInfo()
    const params = {
      ...info
    }
    setAbnormalLoading(true)
    getAsnLeadTime(params)
      .then(res => {
        let dt = res.resultData
        let total = dt.leadTime1 + dt.leadTime2 + dt.leadTime3
        let max = Math.max(total.toFixed(2), dt.leadTime4)
        let percent1 = 0
        let percent2 = 0
        let percent3 = 0
        let percent4 = 0
        if (max) {
          percent1 = (dt.leadTime1 * 100) / max
          percent2 = (dt.leadTime2 * 100) / max
          percent3 = (dt.leadTime3 * 100) / max
          percent4 = (dt.leadTime4 * 100) / max
        }
        let ls = [
          {
            percent: percent1,
            title: formatMessage('languageObj.whOperation.rcvCs'),
            title2: formatMessage('languageObj.whOperation.rcvCsTitle'),
            num: dt.leadTime1
          },
          {
            percent: percent2,
            title: formatMessage('languageObj.whOperation.csHandling'),
            title2: formatMessage('languageObj.whOperation.csHandlingTitle'),
            num: dt.leadTime2
          },
          {
            percent: percent3,
            title: formatMessage('languageObj.whOperation.csDcClose'),
            title2: formatMessage('languageObj.whOperation.csDcCloseTitle'),
            num: dt.leadTime3
          }
        ]
        setAbnormalList(ls)
        let nonLs = [
          {
            percent: percent4,
            num: dt.leadTime4
          }
        ]
        setNonAbnormalList(nonLs)
        let timeLimitLs = [
          {
            value: dt.leadTime5
          }
        ]
        setTableListTimeLimit(timeLimitLs)
      })
      .finally(() => {
        setAbnormalLoading(false)
      })
  }
  const searchDataBtn = () => {
    // 这里可以使用 useCallback 包裹的函数来保证获取最新状态
    // 不过在这个上下文中，可以直接使用 setQueryFlag 的函数式更新
    setQueryFlag(prevQueryFlag => {
      return !prevQueryFlag
    })
  }
  const searchDataBtnSec = () => {
    searchDataFun()
    getAsnCaseTrendFun()
    getReturnGradePieFun()
  }
  const getSearchInfo = type => {
    let info = (formRefCommon.current && formRefCommon.current.getValue()) || {}
    let { whReceiveDate, channel, returnFlag, store } = info
    let whReceiveDateStart = formatStartTime(whReceiveDate, 2, dateFormatYearMonthDay2)
    let whReceiveDateEnd = formatEndTime(whReceiveDate, 2, dateFormatYearMonthDay2)
    let params = {
      ...info,
      channel: channel ? channel.join(',') : channel,
      shopIds: store ? store.join(',') : store,
      returnFlag: returnFlag === 'ALL' ? null : returnFlag,
      whReceiveDateStart,
      whReceiveDateEnd
    }
    if (type === '1' || type === '2') {
      let info1 = (formRefAbnomal.current && formRefAbnomal.current.getValue()) || {}
      let { caseClosedDate } = info1
      let caseClosedDateStart = formatStartTime(caseClosedDate, 2, dateFormatYearMonthDay2)
      let caseClosedDateEnd = formatEndTime(caseClosedDate, 2, dateFormatYearMonthDay2)
      params = { ...params, ...info1, caseClosedDateStart, caseClosedDateEnd }
      if (type === '2') {
        let info2 = (formRefTime.current && formRefTime.current.getValue()) || {}
        params = { ...params, ...info2 }
      }
    }
    if (type === '3') {
      let info3 = (formRefWaterFall.current && formRefWaterFall.current.getValue()) || {}
      params = { ...params, ...info3 }
    }
    delete params.caseClosedDate
    delete params.whReceiveDate
    delete params.store
    return params
  }
  const searchDataFun = () => {
    let info = getSearchInfo('1')
    const params = {
      ...info
    }
    setTableListAbnormalLoading(true)
    getAsnStatsTable(params)
      .then(res => {
        const dt = res.resultData
        let denominator = 0
        let numerator = 0
        let resDt = dt.map(item => {
          if (item.key === '总量') {
            denominator = item.caseClosed
          }
          if (item.key === '异常件') {
            numerator = item.caseClosed
          }
          return {
            ...item,
            title: item.key
          }
        })
        let abnormalLs = [
          {
            value: denominator > 0 ? ((numerator / denominator) * 100).toFixed(1) : 0
          }
        ]
        setTableListAbnormal(abnormalLs)
        setTableList(resDt)
      })
      .finally(() => {
        setTableListAbnormalLoading(false)
      })
  }
  const getAsnCaseTrendFun = () => {
    let info = getSearchInfo('2')
    const params = {
      ...info
    }
    setEchartBarAndLineFlagLoading(true)
    getAsnCaseTrend(params)
      .then(res => {
        const dt = res.resultData
        let dateLs = dt.xAxis.map(item => {
          return initDateFormat(item, dateFormatMonthDayYear2)
        })
        defaultEchartLeftProps.xAxis.data = dateLs
        defaultEchartLeftProps.series = [
          {
            name: 'case closed',
            type: 'bar',
            barMaxWidth: 80,
            label: {
              show: true,
              position: 'inside',
              formatter: params => {
                return numFormat(params.value)
              }
            },
            data: dt['case closed']
          },
          {
            name: 'avg lead time',
            type: 'line',
            yAxisIndex: 1,
            label: {
              show: true,
              position: 'bottom'
            },
            data: dt['avg lead time']
          }
        ]
        setEchartLeftProps(defaultEchartLeftProps)
        setEchartBarAndLineFlag(!echartBarAndLineFlag)
      })
      .finally(() => {
        setEchartBarAndLineFlagLoading(false)
      })
  }
  const getReturnGradePieFun = () => {
    let info = getSearchInfo('1')
    const params = {
      ...info
    }
    setEchartPieFlagLoading(true)
    getReturnGradePie(params)
      .then(res => {
        const dt = res.resultData
        let seriesDatas = []
        _.forIn(dt, (value, key) => {
          seriesDatas.push({ value: value[0], name: key, itemStyle: { color: value[1] } })
        })
        defaultEchartRightProps.series = [
          {
            type: 'pie',
            radius: '43%',
            label: {
              // 通过设置 rich 属性来自定义文本样式，实现换行后左对齐
              formatter: '{name|{b}}\n{value|{d}%}',
              rich: {
                name: {
                  align: 'center',
                  padding: [0, 0, 2, 0]
                },
                value: {
                  align: 'center'
                }
              }
            },
            labelLine: {
              length: 30,
              length2: 20
            },
            data: seriesDatas,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
        setEchartRightProps(defaultEchartRightProps)
        setEchartPieFlag(!echartPieFlag)
      })
      .finally(() => {
        setEchartPieFlagLoading(false)
      })
  }
  const getWaterFallData = () => {
    let info = getSearchInfo('3')
    const params = {
      ...info
    }
    setEchartWaterFallFlagLoading(true)
    getAsnWhStatusWaterfall(params)
      .then(res => {
        const dt = res.resultData
        let series1 = dt.series1
        let series2 = dt.series2
        let seriesDatas = series2.map(item => {
          return {
            value: item
          }
        })
        setEchartWaterfallProps(getWaterfallChartOption(dt.xAxis, series1, seriesDatas))
        setEchartWaterFallFlag(!echartWaterFallFlag)
      })
      .finally(() => {
        setEchartWaterFallFlagLoading(false)
      })
  }
  const getWaterfallChartOption = (dataxAxis, series1, dataSeries) => {
    let option = {
      title: {
        text: formatMessage('languageObj.whOperation.returnOrderInStockStatus'),
        left: 'center'
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        },
        formatter: params => {
          let tar = params[1]
          if (tar) {
            let str = `${tar.marker} ${tar.name}: ${numFormat(tar.value)}`
            return str
          }
          return 0
        }
      },
      grid: {
        left: '3%',
        right: '3%',
        bottom: '3%',
        top: 40,
        containLabel: true
      },
      xAxis: {
        type: 'category',
        data: dataxAxis,
        axisLabel: {
          show: true,
          interval: 0
        }
      },
      yAxis: {
        type: 'value'
      },
      series: [
        {
          name: 'Placeholder',
          type: 'bar',
          stack: 'Total',
          silent: true,
          itemStyle: {
            borderColor: 'transparent',
            color: 'transparent'
          },
          barMaxWidth: '60',
          emphasis: {
            itemStyle: {
              borderColor: 'transparent',
              color: 'transparent'
            }
          },
          data: series1
        },
        {
          name: 'Count ',
          type: 'bar',
          stack: 'Total',
          label: {
            show: true,
            position: 'inside',
            fontWeight: '400',
            color: '#000',
            // fontSize: 14,
            formatter: params => {
              let val = (params.value / 1000).toFixed(1)
              let str = `${numFormat(val)}K`
              return str
            }
          },
          data: dataSeries
        }
      ]
    }
    return option
  }
  return (
    <div>
      <Card>
        <div className="search-bar">
          <SearchBar ref={formRefCommon} searchList={searchListCommon}></SearchBar>
        </div>
      </Card>

      <Row className="mt20" align="middle" gutter={[16, 16]}>
        <Col span={24}>
          <Card>
            <div>
              <div>
                <SearchBar
                  formLayout={{ labelCol: { span: 'auto' }, wrapperCol: { span: 12 } }}
                  ref={formRefWaterFall}
                  searchList={searchListInitWaterFall}
                ></SearchBar>
              </div>
              <Spin spinning={echartWaterFallFlagLoading}>
                <EchartsComMemo
                  echartProps={echartWaterfallProps}
                  rederFlag={echartWaterFallFlag}
                  styleProps={{ height: '350px' }}
                />
              </Spin>
            </div>
          </Card>
        </Col>
      </Row>
      <Card className="mt20" title={formatMessage('languageObj.whOperation.warehouseEfficiencyTitle')}>
        <Row align="middle" gutter={[16, 16]}>
          <Col span={16}>
            <Spin spinning={abnormalLoading}>
              <div className="eff-table-wrapper">
                <AntdTable
                  loading={abnormalLoading}
                  pagination={false}
                  showHeader
                  columns={[
                    // ✅ 左侧行标题列（两层表头都用 rowSpan 合并成一个空格）
                    {
                      title: '',
                      dataIndex: 'rowTitle',
                      key: 'rowTitle',
                      width: 120,
                      onHeaderCell: () => ({ rowSpan: 2 }),
                      render: (_, record) => <span style={{ fontWeight: 600 }}>{record.rowTitle}</span>
                    },

                    // ✅ 第一层表头：阶段标题；第二层表头：阶段描述（children）
                    ...(abnormalList || []).map((item, idx) => ({
                      title: item.title, // 第一行：RCV->CS / CS Handling / CS->DC Close
                      key: `stage_${idx}`,
                      align: 'center',
                      children: [
                        {
                          title: item.title2, // 第二行：中文描述
                          dataIndex: `stage_${idx}`,
                          key: `stage_${idx}_sub`,
                          align: 'center',
                          render: (_, record) => {
                            // 异常件行：正常显示每一格
                            if (record.type === 'abnormal') {
                              const cell = record.cells[idx]
                              return (
                                <Popover
                                  content={
                                    <>
                                      <div className="itemTitle1">{cell.title}</div>
                                      <div className="itemTitle2">{cell.title2}</div>
                                      <div className="itemValue">{numFormat(cell.num)} Hrs</div>
                                    </>
                                  }
                                  title={formatMessage('languageObj.whOperation.abnormal')}
                                >
                                  <span className="eff-value">{numFormat(cell.num)}Hrs</span>
                                </Popover>
                              )
                            }

                            // 非异常件行：✅ 合并显示（第一列显示值，后面列 colSpan=0 隐藏）
                            if (record.type === 'nonAbnormal') {
                              const totalCol = (abnormalList || []).length || 3
                              const isFirst = idx === 0
                              const value =
                                nonAbnormalList?.[0]?.num != null ? `${numFormat(nonAbnormalList?.[0]?.num)} Hrs` : '-'

                              return {
                                children: (
                                  <Popover
                                    content={<div className="itemValue">{value}</div>}
                                    title={formatMessage('languageObj.whOperation.nonAbnormal')}
                                  >
                                    <span className="eff-value">{value}</span>
                                  </Popover>
                                ),
                                props: {
                                  colSpan: isFirst ? totalCol : 0
                                }
                              }
                            }

                            return '-'
                          }
                        }
                      ]
                    }))
                  ]}
                  dataSource={[
                    // ✅ 异常件这一行
                    {
                      key: 'abnormal',
                      type: 'abnormal',
                      rowTitle: formatMessage('languageObj.whOperation.abnormal'),
                      cells: (abnormalList || []).map(i => ({ title: i.title, title2: i.title2, num: i.num }))
                    },

                    // ✅ 非异常件这一行（合并显示）
                    {
                      key: 'nonAbnormal',
                      type: 'nonAbnormal',
                      rowTitle: formatMessage('languageObj.whOperation.nonAbnormal')
                    }
                  ]}
                />
              </div>
            </Spin>
          </Col>

          {/* 右侧：你原来的 returnShelfTime 表格保持不动 */}
          <Col span={8}>
            <ConfigProvider
              theme={{
                components: {
                  Table: {
                    headerBorderRadius: 0
                  }
                }
              }}
            >
              <AntdTable
                loading={abnormalLoading}
                dataSource={tableListTimeLimit}
                columns={tableColumnsTimeLimit}
                pagination={false}
              />
            </ConfigProvider>
          </Col>
        </Row>
      </Card>

      <Card className="mt20" title={formatMessage('languageObj.whOperation.abnormalReason')}>
        <Row gutter={[16, 16]}>
          <Col span={16}>
            <Spin spinning={echartTreeMapFlagLoading}>
              <EchartsComMemo
                echartProps={echartTreeMapProps}
                rederFlag={echartTreeMapFlag}
                styleProps={{ height: '350px' }}
              />
            </Spin>
          </Col>
          <Col span={8}>
            <ConfigProvider
              theme={{
                components: {
                  Table: {
                    headerBorderRadius: 0
                  }
                }
              }}
            >
              <AntdTable
                loading={echartTreeMapFlagLoading}
                scroll={{ y: 310 }}
                dataSource={tableListTreeMap}
                columns={tableColumnsTreeMap}
                pagination={false}
              />
            </ConfigProvider>
          </Col>
        </Row>
      </Card>

      <Card className="mt20">
        <div className="search-bar mb20">
          <SearchBar ref={formRefAbnomal} searchList={searchListInitAbnomal}></SearchBar>
        </div>

        <Row align="middle" gutter={[16, 16]}>
          <Col span={16}>
            <AntdTable
              loading={tableListAbnormalLoading}
              dataSource={tableList}
              columns={tableColumns}
              // pagination={pagination}
              pagination={false}
              // onChange={handleTableChange}
            />
          </Col>
          <Col span={8}>
            <ConfigProvider
              theme={{
                components: {
                  Table: {
                    headerBorderRadius: 0
                  }
                }
              }}
            >
              <AntdTable
                loading={tableListAbnormalLoading}
                dataSource={tableListAbnormal}
                columns={tableColumnsAbnormal}
                // showHeader={false}
                pagination={false}
              />
            </ConfigProvider>
          </Col>
        </Row>
        <Row className="mt20" align="middle" gutter={[16, 16]}>
          <Col span={16}>
            <Card>
              <div style={{ height: '400px' }}>
                <div className="mb20">
                  <SearchBar
                    formLayout={{ labelCol: { span: 'auto' }, wrapperCol: { span: 12 } }}
                    ref={formRefTime}
                    searchList={searchListInitTime}
                  ></SearchBar>
                </div>
                <Spin spinning={echartBarAndLineFlagLoading}>
                  <EchartsComMemo
                    echartProps={echartLeftProps}
                    rederFlag={echartBarAndLineFlag}
                    styleProps={{ height: '350px' }}
                  />
                </Spin>
              </div>
            </Card>
          </Col>
          <Col span={8}>
            <Card>
              <Spin spinning={echartPieFlagLoading}>
                <div style={{ height: '400px' }}>
                  <EchartsComMemo
                    echartProps={echartRightProps}
                    rederFlag={echartPieFlag}
                    styleProps={{ height: '350px' }}
                  />
                </div>
              </Spin>
            </Card>
          </Col>
        </Row>
      </Card>
    </div>
  )
}
export default WhOperation
